import "./Sidebar.css";
import {
  FaTimes,
  FaPowerOff,
  FaTh,
  FaHome,
  FaMoneyBill,
  FaMoneyCheck,
  FaMoneyBillAlt,
  FaMoneyBillWave,
} from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { useContext } from "react";

// hooks
import { AuthContext } from "../../screens/Root/ProtectedRoute";
import { empty } from "../../Utilities/utils";

// images
import appLogo from "../../assets/logo/blue-logo.png";

const FeeSidebar = ({ sidebarOpen, toggleSidebar }) => {
  const { user } = useContext(AuthContext);
  const schoolAvatar = !empty(user) && !empty(user.avatar) ? user.avatar : "";
  const sessionTitle =
    !empty(user) && !empty(user.currentSessionTitle)
      ? user.currentSessionTitle
      : "";
  const termTitle =
    !empty(user) && !empty(user.currentTermTitle) ? user.currentTermTitle : "";
  const reverseSidebar = () => {
    toggleSidebar();
  };

  return (
    <div className={sidebarOpen ? "sidebar_responsive" : ""} id="sidebar">
      <div className="sidebar_title mt-20">
        <div className="flex flex-center direction-column align-center sidebar-image-container">
          <img
            className="sidebar-header-image"
            src={!empty(schoolAvatar) ? schoolAvatar : appLogo}
            alt="logo"
          />
          <p className="text-black text-center mt-20">
            <span>
              {sessionTitle} | {termTitle}
            </span>
          </p>
        </div>
        <FaTimes id="sidebar_close_icon" onClick={toggleSidebar} />
      </div>

      <div className="sidebar_menu">
        {/* sidebar link */}
        <div className="separator">Home</div>
        <NavLink
          onClick={() => reverseSidebar()}
          to="/dashboard"
          style={{ textDecoration: "none" }}
        >
          {({ isActive }) => (
            <div
              className={
                isActive ? "sidebar_link active_menu_link" : "sidebar_link"
              }
            >
              <FaTh className="sidebar_link_icon" />
              <span className="sidebar_link_text">Dashboard</span>
            </div>
          )}
        </NavLink>

        <div className="separator mt-20">Fees</div>
        {/* sidebar link */}
        <NavLink
          onClick={() => reverseSidebar()}
          to="/fees/home"
          style={{ textDecoration: "none" }}
        >
          {({ isActive }) => (
            <div
              className={
                isActive ? "sidebar_link active_menu_link" : "sidebar_link"
              }
            >
              <FaHome className="sidebar_link_icon" />
              <div className="sidebar_link_text">Home</div>
            </div>
          )}
        </NavLink>
        <NavLink
          onClick={() => reverseSidebar()}
          to="/fees/add"
          style={{ textDecoration: "none" }}
        >
          {({ isActive }) => (
            <div
              className={
                isActive ? "sidebar_link active_menu_link" : "sidebar_link"
              }
            >
              <FaMoneyCheck className="sidebar_link_icon" />
              <div className="sidebar_link_text">Add Fee</div>
            </div>
          )}
        </NavLink>
        <NavLink
          onClick={() => reverseSidebar()}
          to="/fees/list-fees"
          style={{ textDecoration: "none" }}
        >
          {({ isActive }) => (
            <div
              className={
                isActive ? "sidebar_link active_menu_link" : "sidebar_link"
              }
            >
              <FaMoneyBill className="sidebar_link_icon" />
              <div className="sidebar_link_text">List Fees</div>
            </div>
          )}
        </NavLink>

        <div className="separator mt-20">Fee Type</div>
        {/* sidebar link */}
        <NavLink
          onClick={() => reverseSidebar()}
          to="/fees/fee-category/add"
          style={{ textDecoration: "none" }}
        >
          {({ isActive }) => (
            <div
              className={
                isActive ? "sidebar_link active_menu_link" : "sidebar_link"
              }
            >
              <FaMoneyBillAlt className="sidebar_link_icon" />
              <div className="sidebar_link_text">Add Fee Category</div>
            </div>
          )}
        </NavLink>
        <NavLink
          onClick={() => reverseSidebar()}
          to="/fees/fee-categories"
          style={{ textDecoration: "none" }}
        >
          {({ isActive }) => (
            <div
              className={
                isActive ? "sidebar_link active_menu_link" : "sidebar_link"
              }
            >
              <FaMoneyBillWave className="sidebar_link_icon" />
              <div className="sidebar_link_text">List Fee Categories</div>
            </div>
          )}
        </NavLink>

        {/* sidebar link */}
        <div className="sidebar_logout mb-20">
          <FaPowerOff className="sidebar_logout_icon" />
          <NavLink to="/logout" className="sidebar_logout_text">
            Logout
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default FeeSidebar;
